export default __webpack_public_path__ + "static/media/pais-arg-dt.3e940d25.png";